import { get, post } from '../request'
/*礼品模块 */
export default {


    /**
     * @description 礼品查询
     * @param {String} params 
     * @returns Object
     */
    getGiftSelect(params) {
        return get(`/gift/select/${params}`)
    },
    /**
     * @description 礼品添加 /修改
     * @param {String} params 
     * @returns Object
     */
    postGiftAddOrUpdate(params) {
        return post(`/gift/updateOrAdd`, params)
    },



    /**
    * @description 礼品查询所有
    * @param {String} params 
    * @returns Object
    */
    getGiftSelectAll(params) {
        return get(`/gift/selectAll`, params, true)
    },
    /**
     * @description 礼品删除byid
     * @param {String} params 
     * @returns Object
     */
    getGiftDelById(params) {
        return get(`/gift/delete/${params}`)
    },


    //安徽 礼包
    /**
      * @description 礼包查询
      * @param {String} params 
      * @returns Object
      */
    getGiftSelectToAH(params) {
        return get(`/acPack/getAcPackDetails?id=${params}`)
    },
    /**
     * @description 礼包添加 
     * @param {String} params 
     * @returns Object
     */
    postGiftAddToAH(params) {
        return post(`/acPack/addAcPack`, params)
    },
    /**
    * @description 礼包修改
    * @param {String} params 
    * @returns Object
    */
    postGiftEditToAH(params) {
        return post(`/acPack/updateAcPack`, params)
    },
    /**
    * @description 礼包删除
    * @param {String} params 
    * @returns Object
    */
    postGiftDelToAH(params) {
        return get(`/acPack/deleteAcPack?id=${params}`)
    },


    /**
    * @description 礼包查询所有
    * @param {String} params 
    * @returns Object
    */
    getGiftSelectAllToAH(params) {
        return get(`/acPack/selectAcPackAll`, params, true)
    },

    /**
         * @description 礼包订单记录查询所有
         * @param {String} params 
         * @returns Object
         */
    getGiftSelectAllOrderRecouds(params) {
        return get(`/acPackOrder/selectAll`, params, true)
    },
    /**
     * @description 礼包订单退款
     * @param {String} params 
     * @returns Object
     */
    getGiftOrderRecouds(params) {
        return get(`/acPackOrder/refundPackOrder`, params, true)
    },

    /**
    * @description 礼包销售统计
    * @param {String} params 
    * @returns Object
    */
    getGiftPackStatistics(params) {
        return get(`/acPackOrder/packOrderSta`, params, true)
    },

      /**
    * @description 礼包补发优惠券
    * @param {String} params 
    * @returns Object
    */
      getGiftPackReissueCoupon(params) {
        return get(`/acPackOrder/couponRetransmission`, params )
    },
      /**
    * @description 礼包核销
    * @param {String} params 
    * @returns Object
    */
      getGiftPackWriteOff(params) {
        return get(`/acPackOrder/verificationPack`, params)
    },
    
    /**
    * @description 商品礼包列表
    * @param {String} params 
    * @returns Object
    */
    getProductPackList(params) {
        return get(`/pack/product/list`, params, true)
    },
    
    /**
    * @description 创建商品礼包（包含商品）
    * @param {Object} params 
    * @returns Object
    */
    postCreateProductPackWithProducts(params) {
        return post(`/pack/product/createWithProducts`, params)
    },
    
    /**
    * @description 商品礼包详情
    * @param {String} packId 
    * @returns Object
    */
    getProductPackDetail(packId) {
        return get(`/pack/product/detail/${packId}`, {}, true)
    },
    
    /**
    * @description 更新商品礼包（包含商品）
    * @param {Object} params 
    * @returns Object
    */
    postUpdateProductPackWithProducts(params) {
        return post(`/pack/product/updateWithProducts`, params)
    },
    
    /**
    * @description 删除商品礼包
    * @param {String} packId 
    * @returns Object
    */
    deleteProductPack(packId) {
        return post(`/pack/product/delete/${packId}`)
    },

    /**
    * @description 按礼包订单状态导出
    * @param {Object} params - { payStatus, packName, outOrderNo, phone, startTime, endTime }
    * @returns Object
    */
    exportGiftOrderExcel(params) {
        return get(`/acPackOrder/selectAllExcel`, params, true)
    },
}